import {conditionVariables} from '../../utils/conditions.js'
import type {ConditionType} from '../../utils/conditions.js'

/** The variables of an order for a condition and their types, the value comes from getOrderConditionValue (orders.ts) */
export const ORDER_CONDITION_TYPES = {
    customer: 'choice',
    sender: 'text',
    creationTime: 'time',
    creationTimeOfDay: 'time',
    startTime: 'time',
    endTime: 'time',
    colliType: 'list',
    colliAmount: 'number',
    colliWeight: 'number',
    colliVolume: 'number',
    options: 'list',
    deliveryZone: 'list',
    postalCode: 'postalCode',
    notes: 'text',
    reference: 'text',
    instruction: 'text',
    street: 'text',
    city: 'text'
} as const satisfies Record<string, ConditionType>

export type OrderConditionVariable = keyof typeof ORDER_CONDITION_TYPES

export const ORDER_CONDITION_VARIABLES = conditionVariables(ORDER_CONDITION_TYPES)

const withoutVariables = (exclude: OrderConditionVariable[]) => {
    return ORDER_CONDITION_VARIABLES.filter((variable) => !exclude.includes(variable)) as [OrderConditionVariable, ...OrderConditionVariable[]]
}

/**
 * The variables of a partner connection: those of an order without Bezorggebied and Postcode. Orders received from a
 * partner have a sender (Afzender) instead of a customer.
 */
export const PARTNER_CONDITION_VARIABLES = {
    outgoing: withoutVariables(['sender', 'deliveryZone', 'postalCode']),
    incoming: withoutVariables(['customer', 'deliveryZone', 'postalCode'])
}
